import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { isJwtExpired } from '../utils/jwt';
import { resetUnauthorizedLatch } from '../services/http';

interface UserState {
  phone: string | null;
  userId: string | null;
  token: string | null;
  firstName: string;
  lastName: string;
  isLoggedIn: boolean;
  setPhone: (phone: string) => void;
  setName: (name: string) => void;
  login: (data: {
    phone: string;
    userId: string;
    token: string;
    firstName: string;
    lastName?: string | null;
  }) => void;
  logout: () => void;
  /** Сбросить протухшую сессию из localStorage (без навигации). */
  clearExpiredSession: () => void;
}

export const useUserStore = create<UserState>()(
  persist(
    (set, get) => ({
      phone: null,
      userId: null,
      token: null,
      firstName: 'Гость',
      lastName: '',
      isLoggedIn: false,
      setPhone: (phone) => set({ phone }),
      setName: (name) => set({ firstName: name }),
      login: ({ phone, userId, token, firstName, lastName }) => {
        resetUnauthorizedLatch();
        set({ phone, userId, token, firstName, lastName: lastName?.trim() ?? '', isLoggedIn: true });
      },
      logout: () => {
        resetUnauthorizedLatch();
        set({ phone: null, userId: null, token: null, firstName: 'Гость', lastName: '', isLoggedIn: false });
      },
      clearExpiredSession: () => {
        const { token, phone, userId } = get();
        if (!token && !phone && !userId) return;
        if (token && !isJwtExpired(token)) return;
        get().logout();
      },
    }),
    {
      name: 'user-session',
      onRehydrateStorage: () => (state) => {
        state?.clearExpiredSession();
      },
    },
  ),
);

/** Реальная авторизация: телефон + валидный JWT. */
export function selectIsSessionValid(state: UserState): boolean {
  return !!(state.phone && state.userId && state.token && !isJwtExpired(state.token));
}
